import DateEnum from './material/DatePicker/enum';
export var dVariant = 'outlined';
export var successSnack = { variant: 'success' };
export var warningSnack = { variant: 'warning' };
export var DATE_FORMAT = DateEnum.daFormatP;
export var TIME_FORMAT = DateEnum.ti4Format;
export var emptyErrMsg = '請填寫這個欄位。';
export var dateErrMsg = '請輸入正確的時間。';
